
<template>
  <section class="pp-brands-section">

    <div class="container">

      <!-- SECTION HEADER -->
      <div class="pp-brands-heading">

        <div class="pp-brands-heading-left">

          <span class="pp-brands-eyebrow">
            NOTRE SÉLECTION
          </span>

          <h2>
            Les plus grandes
            <span>marques</span>
            de pneus
          </h2>

          <p>
            Retrouvez les marques incontournables du pneumatique
            et choisissez les pneus adaptés à votre véhicule.
          </p>

        </div>

        <router-link
          to="/brands"
          class="pp-brands-view-all"
        >
          Voir toutes les marques
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6"/>
          </svg>
        </router-link>

      </div>

      <!-- BRANDS GRID -->
      <div class="pp-brands-grid">

        <router-link
          v-for="(brand, index) in brands"
          :key="brand.slug"
          :to="{
            path: '/products',
            query: { brand: brand.name }
          }"
          class="pp-brand-card"
          :style="{ '--brand-delay': (index * 50) + 'ms' }"
          :aria-label="'Découvrir les pneus ' + brand.name"
        >

          <div class="pp-brand-logo-wrap">

            <img
              v-if="!failedImages[brand.slug]"
              :src="brand.logo"
              :alt="'Logo ' + brand.name"
              loading="lazy"
              @error="onImageError(brand.slug)"
            />

            <span v-else class="pp-brand-fallback">
              {{ brand.name }}
            </span>

          </div>

          <span class="pp-brand-arrow" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M13 6l6 6-6 6"/>
            </svg>
          </span>

        </router-link>

        <!-- ALL BRANDS CARD -->
        <router-link
          to="/brands"
          class="pp-brand-card pp-all-brands"
        >

          <div class="pp-all-brands-icon">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="8" cy="8" r="2.5"/>
              <circle cx="16" cy="8" r="2.5"/>
              <circle cx="8" cy="16" r="2.5"/>
              <circle cx="16" cy="16" r="2.5"/>
            </svg>
          </div>

          <span>
            Toutes les marques
          </span>

          <svg class="pp-all-arrow" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6"/>
          </svg>

        </router-link>

      </div>

      <!-- BOTTOM TEXT -->
      <div class="pp-brands-bottom">
        <span class="pp-brands-line"></span>

        <p>
          Trouvez facilement la marque de pneus qui vous convient.
        </p>

        <span class="pp-brands-line"></span>
      </div>

    </div>

  </section>
</template>

<script>
export default {
  name: "BrandsSection",

  data() {
    return {
      failedImages: {},

      brands: [
        {
          name: "Michelin",
          slug: "michelin",
          logo: "/assets/images/brands/michelin.png",
        },
        {
          name: "Continental",
          slug: "continental",
          logo: "/assets/images/brands/continental.png",
        },
        {
          name: "Bridgestone",
          slug: "bridgestone",
          logo: "/assets/images/brands/bridgestone.png",
        },
        {
          name: "Goodyear",
          slug: "goodyear",
          logo: "/assets/images/brands/goodyear.png",
        },
        {
          name: "Pirelli",
          slug: "pirelli",
          logo: "/assets/images/brands/pirelli.png",
        },
        {
          name: "Dunlop",
          slug: "dunlop",
          logo: "/assets/images/brands/dunlop.png",
        },
        {
          name: "Hankook",
          slug: "hankook",
          logo: "/assets/images/brands/hankook.png",
        },
        {
          name: "Kleber",
          slug: "kleber",
          logo: "/assets/images/brands/kleber.png",
        },
        {
          name: "Kumho",
          slug: "kumho",
          logo: "/assets/images/brands/kumho.png",
        },
        {
          name: "Nexen",
          slug: "nexen",
          logo: "/assets/images/brands/nexen.png",
        },
      ],
    };
  },

  methods: {
    onImageError(slug) {
      this.$set(this.failedImages, slug, true);
    },
  },
};
</script>

<style scoped>
/* ======================================
   PRODU PNEU - BRANDS SECTION
====================================== */

.pp-brands-section {
  position: relative;
  padding: 75px 0 55px;
  background: linear-gradient(
    180deg,
    #f7f9fb 0%,
    #f0f3f6 100%
  );
  overflow: hidden;
  font-family: "Poppins", sans-serif;
}

/* HEADER */

.pp-brands-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 30px;
  margin-bottom: 32px;
}

.pp-brands-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #ff7900;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 13px;
}

.pp-brands-eyebrow::before {
  content: "";
  display: block;
  width: 20px;
  height: 2px;
  background: #ff7900;
}

.pp-brands-heading h2 {
  color: #1d232a;
  font-size: clamp(26px, 2.7vw, 36px);
  line-height: 1.3;
  font-weight: 900;
  letter-spacing: -1px;
  margin: 0 0 12px;
}

.pp-brands-heading h2 span {
  color: #ff7900;
}

.pp-brands-heading p {
  color: #77808a;
  font-size: 13px;
  line-height: 1.8;
  margin: 0;
  max-width: 620px;
}

.pp-brands-view-all {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #ff7900;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none !important;
  padding-bottom: 6px;
  transition: gap .25s ease;
}

.pp-brands-view-all:hover {
  color: #e66d00;
  gap: 15px;
}

.pp-brands-view-all svg,
.pp-brand-arrow svg,
.pp-all-arrow {
  width: 18px;
  height: 18px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* BRANDS GRID */

.pp-brands-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 13px;
}

.pp-brand-card {
  position: relative;
  height: 115px;
  padding: 18px;
  background: #fff;
  border: 1px solid #e8edf1;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none !important;
  overflow: hidden;
  transition:
    transform .3s ease,
    border-color .3s ease,
    box-shadow .3s ease;
}

.pp-brand-card::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: #ff7900;
  transition: all .35s ease;
}

.pp-brand-card:hover {
  transform: translateY(-5px);
  border-color: #ffd3ab;
  box-shadow: 0 13px 28px rgba(25, 35, 45, .09);
}

.pp-brand-card:hover::before {
  left: 0;
  width: 100%;
}

.pp-brand-logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 65px;
}

.pp-brand-logo-wrap img {
  display: block;
  width: 100%;
  max-width: 135px;
  max-height: 58px;
  object-fit: contain;
  transition: transform .3s ease;
}

.pp-brand-card:hover .pp-brand-logo-wrap img {
  transform: scale(1.07);
}

.pp-brand-fallback {
  font-size: 15px;
  font-weight: 900;
  color: #293039;
  text-align: center;
}

.pp-brand-arrow {
  position: absolute;
  right: 12px;
  top: 11px;
  color: #ff7900;
  opacity: 0;
  transform: translateX(-7px);
  transition: .25s ease;
}

.pp-brand-card:hover .pp-brand-arrow {
  opacity: 1;
  transform: translateX(0);
}

/* ALL BRANDS CARD */

.pp-all-brands {
  flex-direction: column;
  gap: 7px;
  background: #1b2229;
  border-color: #1b2229;
}

.pp-all-brands:hover {
  background: #252e37;
  border-color: #ff7900;
}

.pp-all-brands-icon {
  width: 30px;
  height: 30px;
  color: #ff7900;
}

.pp-all-brands-icon svg {
  width: 100%;
  height: 100%;
  stroke: currentColor;
  stroke-width: 1.8;
}

.pp-all-brands > span {
  color: #fff;
  font-size: 11px;
  font-weight: 750;
  text-align: center;
}

.pp-all-arrow {
  color: #ff7900;
  width: 15px;
  height: 15px;
}

/* BOTTOM */

.pp-brands-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 22px;
  margin-top: 30px;
}

.pp-brands-bottom p {
  color: #9299a0;
  font-size: 11px;
  margin: 0;
  white-space: nowrap;
}

.pp-brands-line {
  width: 70px;
  max-width: 15%;
  height: 1px;
  background: #dce1e5;
}

/* RESPONSIVE */

@media (max-width: 1199px) {
  .pp-brands-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .pp-brands-section {
    padding: 55px 0 45px;
  }

  .pp-brands-heading {
    flex-direction: column;
    align-items: flex-start;
    gap: 17px;
  }

  .pp-brands-heading h2 {
    font-size: 28px;
  }

  .pp-brands-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .pp-brand-card {
    height: 95px;
    padding: 13px;
  }
}

@media (max-width: 480px) {
  .pp-brands-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;
  }

  .pp-brand-card {
    height: 90px;
  }

  .pp-brand-logo-wrap img {
    max-height: 48px;
  }

  .pp-brands-heading h2 {
    font-size: 25px;
  }

  .pp-brands-heading p {
    font-size: 12px;
  }

  .pp-brands-bottom p {
    white-space: normal;
    text-align: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pp-brand-card,
  .pp-brand-card::before,
  .pp-brand-logo-wrap img,
  .pp-brand-arrow {
    transition: none;
  }
}
</style>
